module.exports = __webpack_public_path__ + "static/media/yellow-card.svg.4e45cfe6.png";